<template>
  <div id="app">
    <el-container>
      <el-header>
        <div class="logo">
          <img src="./assets/logo.png" alt />
        </div>
        <el-menu
          :default-active="defaultActive"
          class="el-menu-demo"
          mode="horizontal"
          @select="handleSelect"
          :router="router"
        >
          <el-menu-item index="/">首页</el-menu-item>
          <el-menu-item index="/activity">志愿活动</el-menu-item>
          <el-menu-item index="/train">志愿者培训</el-menu-item>
          <el-menu-item index="/notice">公示公告</el-menu-item>
          <el-menu-item index="/directories">志愿者名录</el-menu-item>
          <el-menu-item index="/bank">时间银行</el-menu-item>
          <el-menu-item index="/cooperation">对外合作</el-menu-item>
          <!-- <el-menu-item index="/login">用户登陆</el-menu-item> -->
          <el-submenu index="2">
            <template slot="title">{{ tokenflag ? "已登录" : "登陆注册" }}</template>
            <el-menu-item v-if="!tokenflag" @click="loginFlag = true">登陆</el-menu-item>
            <el-menu-item v-if="!tokenflag" index="/register">注册</el-menu-item>
            <el-menu-item v-if="tokenflag" @click="loginout">退出登录</el-menu-item>
          </el-submenu>
        </el-menu>
      </el-header>
      <el-main>
        <router-view />
      </el-main>
      <div class="footer">
        <div class="footer-content">
          <el-row :gutter="120">
            <el-col :span="18">
              <div class="footer_nav">
                <div class="nav_tag">
                  <span>商务合作</span>
                  <span>已经反馈</span>
                  <span>关于我们</span>
                  <span>联系我们</span>
                  <span>版权声明</span>
                  <span>隐私政策</span>
                </div>
                <div class="nav_text">
                  中国红十字会总会事业发展中心所有 |
                  中国红十字会总会事业发展中心所有 | 京ICP备案19041768号
                </div>
              </div>
            </el-col>
            <el-col :span="6">
              <div class="logo">
                <img src="./assets/logo.png" alt="" />
              </div>
            </el-col>
          </el-row>
          <div class="link">
            <span>友情链接:</span>
          </div>
        </div>
      </div>
    </el-container>
    <div class="login" v-if="loginFlag">
      <div class="login_info">
        <h3 class="login-title">用户登陆</h3>
        <el-form
          :model="dataForm"
          :rules="dataRule"
          ref="dataForm"
          @keyup.enter.native="login()"
          status-icon
        >
          <el-form-item prop="username">
            <el-input v-model="dataForm.username" placeholder="用户名">
            </el-input>
          </el-form-item>
          <el-form-item prop="password">
            <el-input
              v-model="dataForm.password"
              type="password"
              placeholder="密码"
            >
            </el-input>
          </el-form-item>
        </el-form>
        <div class="login_bit">
          <el-button class="w-percent-100" @click="loginFlag = false">取消</el-button>
          <el-button type="primary" @click="login()" class="w-percent-100">确认</el-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      router: true,
      defaultActive: "/",
      isShow: false,
      loginFlag: false,
      tokenflag: false,
      dataForm: {
        username: "",
        password: "",
        uuid: "",
        captcha: "123123",
      },
    };
  },
  computed: {
    dataRule() {
      return {
        username: [
          {
            required: true,
            message: "必填项不能为空",
            trigger: "blur",
          },
        ],
        password: [
          {
            required: true,
            message: "必填项不能为空",
            trigger: "blur",
          },
        ],
      };
    },
  },
  mounted() {
    this.verifyToken()
  },
  methods: {
    async login() {
      let type = false;
      this.$refs.dataForm.validate((valid) => {
        if (!valid) type = true;
      });
      if (type) return;
      console.log(this.dataForm);
      this.dataForm.uuid = this.dataForm.username;
      let {
        data: { code, data },
      } = await this.$http.post("/login", this.dataForm);
      if (code != 0) return this.$message.warning("账号或密码错误");
      this.$message.success("登陆成功!");
      localStorage.setItem("token", data.token);
      this.loginFlag = false
      this.verifyToken()
    },
    handleSelect(key) {
      // this.isShow = this.defaultActive != key;
      // window.console.log(this.isShow);
    },
    loginout() {
      localStorage.removeItem("token");
      this.verifyToken()
    },
    verifyToken() {
      let token = localStorage.getItem("token");
      if (token) {
        this.getUserInfo()
      } else {
        this.tokenflag = false;
      }
    },
    async getUserInfo() {
      let { data: { data, code }} = await this.$http.get('/sys/user/info')
      if(code != 0) return
      this.tokenflag = true;
      localStorage.setItem('userinfo', JSON.stringify(data))
    }
  },
};
</script>

<style lang="scss">
@import "./assets/style/global.css";
@import "./assets/style/config.scss";
@keyframes totop {
  0% {
    top: 70%;
    opacity: 0;
  }
  100% {
    top: 50%;
    opacity: 1;
  }
}
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  .login {
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    background-color: rgba($color: #000000, $alpha: .4);
    .login_info {
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
      background-color: #fff;
      box-shadow: 0px 0px 2px #ffffff;
      padding: 20px;
      width: 325px;
      border-radius: 10px;
      animation: totop .5s;
      .login-title {
        padding-bottom: 15px;
        text-align: center;
      }
      .login_bit {
        display: flex;
        justify-content: flex-end;
        align-items: center;
      }
    }
  }
}
.container {
  width: 1240px;
  margin: 0 auto;
}
.el-header {
  .el-menu--horizontal > .el-menu-item.is-active {
    border-bottom: 2px solid $--color-primary;
  }
  .el-menu.el-menu--horizontal {
    border: none;
  }
  display: flex;
  justify-content: space-between;
  align-content: center;
  width: 1240px;
  margin: 0 auto;
  .logo {
    width: 280px;
    padding: 2px;
    img {
      height: 100%;
      width: auto;
      object-fit: cover;
    }
  }
}
.el-main {
  padding: 0 !important;
}
.footer {
  background-color: $--color-primary;
  .footer-content {
    width: 1240px;
    margin: 0 auto;
    padding: 20px 0;
    .footer_nav {
      .nav_tag {
        display: flex;
        justify-content: space-between;
        font-size: 18px;
        line-height: 38px;
        color: #f0f0f0;
      }
      .nav_text {
        font-size: 14px;
        color: beige;
      }
    }
    .logo {
      img {
        width: 100%;
        height: 100%;
      }
    }
    .link {
      font-size: 14px;
      color: #ccc5c5;
    }
  }
}
</style>
